"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_core_1 = require("@patternfly/react-core");
const SectionTitle = ({ title, testId }) => (react_1.default.createElement(react_core_1.GridItem, null,
    react_1.default.createElement(react_core_1.TextContent, null,
        react_1.default.createElement(react_core_1.Text, { "data-testid": testId, component: react_core_1.TextVariants.h3 }, title))));
exports.default = SectionTitle;
//# sourceMappingURL=SectionTitle.js.map